import { render } from "./Upgrade.vue?vue&type=template&id=0390dd58&scoped=true"
import script from "./Upgrade.vue?vue&type=script&lang=js"
export * from "./Upgrade.vue?vue&type=script&lang=js"

import "./Upgrade.vue?vue&type=style&index=0&id=0390dd58&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0390dd58"]])

export default __exports__